module.exports = __webpack_public_path__ + "images/img-_CxPFDI.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/offer.jpg
// module id = 2002
// module chunks = 0